const socialConfigEnv = {
  GOOGLE_CLIENT_ID: '334156907554-jghqe3ig92un4n6bm9vtvjuemovr6e58.apps.googleusercontent.com',
  FACEBOOK_APP_ID: '1098800348579712',
}

export const socialConfig = {
  google: {
    clientId: socialConfigEnv.GOOGLE_CLIENT_ID,
  },
  facebook: {
    appId: socialConfigEnv.FACEBOOK_APP_ID,
  },
} as const
